// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AxQTW","importantInfo":"styles_importantInfo__2yrwu"};